import { RECEIVE_LOGO, RECEIVE_ACCOUNT_ID, FETCH_ERROR } from "../actions/portalDetailsActions";
import { PortalDetailsState } from "../state/fullState";
const initState: PortalDetailsState = {
    logoUrl: "",
    fetchError: false
}

const portalDetailsReducer = (state: PortalDetailsState = initState, action) => {
    Object.freeze(state);
    switch (action.type) {
        case RECEIVE_LOGO: {
            return {
                ...state,
                logoUrl: action.payload,
                fetchError: false
            }
        }
        case RECEIVE_ACCOUNT_ID: {
            return {
                ...state,
                accountId: action.payload,
                fetchError: false
            }
        }
        case FETCH_ERROR: {
            return {
                ...state,
                fetchError: true
            }
        }
        default:
            return state;
    }
}

export default portalDetailsReducer;